import { Step } from 'signup-constants/Step';
import { isEmailVerificationSignup } from '../app/verificationTypeSelectors';
import { isPostVerification } from '../flow-settings/settingsSelectors';
import { getCompletedSteps, getCurrentStep, getNextSteps, getPostAccountCreationSteps, getPostVerificationSteps, getPreVerificationSteps } from '../store/flow/selectors';
import { getIsActiveAndAssignedToVariant } from '../store/experiments/selectors';
import { ExperimentKeys } from '../experiments/ExperimentKeys';
import { ExperimentParameterGroup } from '../experiments/ExperimentParameterGroup';
import { getShouldShowSidePanel } from '../utils/getShouldShowSidePanel';
import { getFlowKey } from '../routing/getFlowKey';
import { Flow } from 'signup-constants/Flow';
import { isEligibleForACQ177ProductisedFlow } from '../utils/gtkm/isEligibleForACQ177ProductisedFlow';
const UNCOUNTABLE_STEPS = [Step.ExistingUser, Step.LandingPage, Step.ResendEmail, Step.Verification, Step.CodeVerification, Step.HublessNoAccount, Step.IntegrationsAccountCreated];
const BADGE_UNCOUNTABLE_STEPS = [Step.LoadingPage, Step.LandingPage, Step.ResendEmail, Step.Verification, Step.CodeVerification, Step.Password, Step.ExistingUser, Step.ExistingAccounts, Step.HublessNoAccount, Step.IntegrationsAccountCreated, Step.WordpressAuthorization, Step.IntegratedAppAuthorization, Step.WordpressConnectRedirect, Step.IntegratedAppConnectRedirect, Step.IntegratedAppAuthorizationError, Step.WordpressAuthorizationError];
const removeUncountableSteps = steps => {
  return steps ? steps.filter(stepKey => UNCOUNTABLE_STEPS.indexOf(stepKey) === -1) : [];
};
export const removeBadgeUncountableSteps = steps => {
  return steps ? steps.filter(stepKey => BADGE_UNCOUNTABLE_STEPS.indexOf(stepKey) === -1) : [];
};
export const getStepNumbering = (state, nextSteps = []) => {
  const preVerification = getPreVerificationSteps(state);
  const postVerification = getPostVerificationSteps(state);
  const postAccountCreation = getPostAccountCreationSteps(state);
  const pre = removeUncountableSteps(preVerification);
  const post = removeUncountableSteps(postVerification);
  const postAccountCreationSteps = removeUncountableSteps(postAccountCreation);
  const previousSteps = removeUncountableSteps(getCompletedSteps(state));
  const previousStepsCount = previousSteps.length;
  nextSteps = removeUncountableSteps(nextSteps);
  const nextStepsCount = nextSteps.length;
  const currentStep = getCurrentStep(state);
  const shouldAddExtra = currentStep ? 1 : 0;
  const postVerificationCount = isPostVerification() ? nextStepsCount + previousStepsCount + shouldAddExtra : post.length + postAccountCreationSteps.length;
  const totalSteps = !isEmailVerificationSignup(state) ? nextStepsCount + previousStepsCount + shouldAddExtra : pre.length + postVerificationCount;
  const currentStepCount = isPostVerification() ? previousStepsCount + pre.length + 1 : previousStepsCount + 1;
  return {
    currentStep: currentStepCount,
    totalSteps
  };
};
export const getBadgeStepNumbering = (state, nextSteps = []) => {
  const completedSteps = removeBadgeUncountableSteps(getCompletedSteps(state));
  const cleanedNextSteps = removeBadgeUncountableSteps(nextSteps);
  const flowKey = getFlowKey();

  // For these flows, we will redirect users into the setup flow, so we need to include the additional steps in the total step count.
  const flowWithExtraSteps = [Flow.Crm, Flow.Sales, Flow.Marketing, Flow.Service];
  const completedStepsCount = completedSteps.length;
  const nextStepsCount = cleanedNextSteps.length;
  const currentStep = completedStepsCount + 1;
  const extraStepsCount = flowWithExtraSteps.includes(flowKey) ? 5 : 1;
  const totalSteps = nextStepsCount + completedStepsCount + extraStepsCount;
  return {
    currentStep,
    totalSteps
  };
};
export const getGTKMBadgeStepNumbering = (state, nextSteps = []) => {
  const completedSteps = removeBadgeUncountableSteps(getCompletedSteps(state));
  const cleanedNextSteps = removeBadgeUncountableSteps(nextSteps);
  const completedStepsCount = completedSteps.length;
  const nextStepsCount = cleanedNextSteps.length;
  const currentStepCount = completedStepsCount + 1;
  let totalSteps = 0;
  if (nextSteps.includes(Step.LoadingPage)) {
    totalSteps = nextStepsCount + completedStepsCount + 8;
  } else {
    // Add 5 to the total steps to account for the progress badge
    totalSteps = nextStepsCount + completedStepsCount + 5;
  }
  return {
    currentStep: currentStepCount,
    totalSteps
  };
};
export const getCurrentStepNumbering = state => {
  const nextSteps = getNextSteps(state);
  const shouldShowSidePanel = getShouldShowSidePanel();
  const isAssignedToACQ177VariantA = isEligibleForACQ177ProductisedFlow(state) || getIsActiveAndAssignedToVariant(state, ExperimentKeys.ACQ0177, [ExperimentParameterGroup.Variant_A]);
  const isAssignedToGTKM = isAssignedToACQ177VariantA;
  if (isAssignedToGTKM) {
    return getGTKMBadgeStepNumbering(state, nextSteps);
  }
  if (shouldShowSidePanel) {
    return getBadgeStepNumbering(state, nextSteps);
  }
  return getStepNumbering(state, nextSteps);
};
export const areTherePostAccountCreationSteps = state => {
  const postAccountCreation = getPostAccountCreationSteps(state);
  return postAccountCreation.length > 0;
};
export const onlyMobileAppPromptStep = state => {
  const postAccountCreation = getPostAccountCreationSteps(state);
  return postAccountCreation.length > 0 && postAccountCreation[0] === Step.MobileAppPrompt;
};